// Scrolls to show the end of a container as content is added
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToEnd()
    this.observer = new MutationObserver(() => this.smoothScrollToEnd())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  scrollToEnd() {
    if (this.isScrollable()) {
      this.element.scrollTop = this.element.scrollHeight
    } else {
      this.element.scrollIntoView({ block: 'end' })
    }
  }

  smoothScrollToEnd() {
    if (this.isScrollable()) {
      this.element.scrollTo({ top: this.element.scrollHeight, behavior: 'smooth' })
    } else {
      this.element.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }

  isScrollable() {
    return this.element.scrollHeight > this.element.clientHeight
  }
}
